module.exports = __webpack_public_path__ + "static/img/duraframe-with-rail-mount-bracket.3d4d7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/duraframes/duraframe-with-rail-mount-bracket.jpg
// module id = 731
// module chunks = 0